var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.validationObject
    ? _c("div", { staticClass: "row" }, [
        _c(
          "label",
          {
            staticClass: "col-sm-3 font-weight-bold col-form-label",
            attrs: { for: _vm.id }
          },
          [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
            _vm.isRequired && !_vm.isDisabled
              ? _c("required-label")
              : _vm.validationObject.$invalid
              ? _c("transition", { attrs: { name: "fade" } }, [
                  _c("span", { staticClass: "badge badge-danger" }, [
                    _vm._v("Ongeldig")
                  ])
                ])
              : _vm.isDirty && !_vm.validationObject.$invalid
              ? _c("transition", { attrs: { name: "fade" } }, [
                  _c("span", { staticClass: "badge badge-warning" }, [
                    _vm._v("Aangepast")
                  ])
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-7" }, [
          _c("input", {
            class: [
              _vm.validationObject.$invalid ? "is-invalid" : "",
              "form-control"
            ],
            attrs: {
              type: "text",
              id: _vm.id,
              placeholder: _vm.label,
              disabled: _vm.isDisabled
            },
            domProps: { value: _vm.bic },
            on: {
              input: function($event) {
                return _vm.updateValue($event.target.value)
              }
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }